import React from "react";
import Image from "next/image";
import { IMAGE_PATHS_V2 } from "@/shared/consts/imagesPaths";
import { BrowserContext } from "context";
import { ImageResponsive } from "@/components/commons/images/ImageResponsive.component";

export const LoaderRedirectPage = () => {
  const { isMobile } = React.useContext(BrowserContext)
  return (
    <div style={{
      width: '100%',
      height: '100vh',
      backgroundImage: `url("${IMAGE_PATHS_V2.bg}loader_bg.png")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: isMobile ? 'cover' : 'contain',
      backgroundPosition: 'center',
      backgroundColor: '#1A1719',
    }} className='flex items-center justify-center flex-column bg-black-primary gap-20 gap-27--tablet'>
      <Image
        src={IMAGE_PATHS_V2.bg + 'landing/bg_icon_green.svg'}
        alt='logo_icon'
        width={isMobile ? 117 : 163}
        height={isMobile ? 117 : 163}
      />
      <div style={{
        width: isMobile ? 327.73 : 453.89
      }}>
        <ImageResponsive
            alt="Creatorland logo"
            src={`${IMAGE_PATHS_V2.logos}creatorland_logo_soft_green.png`}
            priority={true}
            />
      </div>
      <div style={{
        width: '80%',
        height: '1px',
        maxWidth: '580px',
      }} className="bg-white-primary"></div>
      <p className='cl-white-primary text-20 font-bold text-30--tablet m-0'>Welcome to the land of <span className="cl-pink-secondary font-bold">opportunities.</span></p>
    </div>
  )
}